import { formatCurrency, formatNumber } from "ui";

export type ValueFormat = "currency" | "percentage" | "number";

/**
 * Returns the y-axis (`formatYLabel`, compact) and tooltip (`formatValue`,
 * full) formatters for a chart value format.
 */
export function getValueFormatters(format: ValueFormat) {
  if (format === "currency") {
    return {
      formatYLabel: (value: number) =>
        formatCurrency({ amount: value, currency: "USD", compact: true }),
      formatValue: (value: number) =>
        formatCurrency({ amount: value, currency: "USD" }),
    };
  }

  if (format === "percentage") {
    return {
      formatYLabel: (value: number) => `${value}%`,
      formatValue: (value: number) => `${value}%`,
    };
  }

  return {
    formatYLabel: (value: number) => formatNumber({ value, compact: true }),
    formatValue: (value: number) => formatNumber({ value }),
  };
}
